export default __webpack_public_path__ + "static/media/location-on.0fe756ba.svg";